var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMask = function SvgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "m8.545 13.385-1.809-.936C4.56 11.324 2 12.96 2 15.476v3.276c0 .898.34 1.756.966 2.379 2.277 2.27 6.625 4.1 6.625 4.1M8.545 13.385C13.455 13.385 13.455 10 20 10c6.546 0 6.546 3.385 11.455 3.385m-22.91 0s-.386 3.593-.097 7.214c.132 1.65 1.143 4.632 1.143 4.632m0 0C11.467 29 15.449 31 20 31s8.533-1.998 10.409-5.77m1.046-11.845 1.809-.936C35.44 11.324 38 12.96 38 15.476v3.276c0 .898-.34 1.756-.966 2.379-2.277 2.27-6.625 4.1-6.625 4.1m1.046-11.846s.386 3.593.097 7.214c-.132 1.65-1.143 4.632-1.143 4.632M24 18.75c-3.273-1.691-4.727-1.691-8 0"
  })));
};
export default SvgMask;